import React, { memo } from 'react';
import { StyleSheet } from 'react-native';

import { pointerEventsStyles, getCloudinaryUrl, Image, theme } from '@sg/garnish';

import { INGREDIENT_CARD_IMAGE_WIDTH } from '../../../../constants';
import { IMAGE_SIZE } from '../../CustomizationActiveIngredient.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientImage = memo((props: Props) => {
  const { url, alt } = props;

  const formattedSource = getCloudinaryUrl(url, { crop: 'scale', width: INGREDIENT_CARD_IMAGE_WIDTH }); // prettier-ignore

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Image
      source={formattedSource}
      style={[styles.image, pointerEventsStyles.none]}
      alt={alt}
      // NOTE: This is to prevent the image from being selected/dragged.
    />
  );
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  image: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    borderRadius: IMAGE_SIZE,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  url: string;
  alt: string;
};
